import { Controller } from "@hotwired/stimulus"

// Filtre live du tableau Settings users dans /admin/prospection?tab=users.
// Masque les rows dont data-search ne contient pas la query (match case-insensitive).
export default class extends Controller {
  static targets = ["input", "row", "count"]

  filter() {
    const q = this.inputTarget.value.trim().toLowerCase()
    let visible = 0
    this.rowTargets.forEach(row => {
      const haystack = row.dataset.search || ""
      const match = q === "" || haystack.includes(q)
      row.style.display = match ? "" : "none"
      if (match) visible++
    })
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${visible} user${visible > 1 ? "s" : ""}`
    }
  }
}
